import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const CommercialAppraisalStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload an appraisal for your property. This is a professional valuation of your property.
        This is an optional step and can be skipped if you do not have any future expenditures to
        upload.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of the property</li>
          <li>Repair/maintenance documents</li>
          <li>Inspection reports</li>
          <li>Supporting paperwork</li>
        </ul>
      </div>
    </>
  );
};
